export const cleaner = {
    cleanInput: function (input) {
        var s = input.replace(/\\\//g, '/').replace(/\\r\\n/g, '');
        return s;
    }
};
